/* Bow Buddy — product offers: quantity tiers + add-ons that ride along with Add to cart */
(function () {
  'use strict';
  var root = document.querySelector('[data-bb-offers]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var sid = root.dataset.section;
  var prices = {};
  try { prices = JSON.parse(document.querySelector('[data-bb-offers-variants="' + sid + '"]').textContent); } catch (e) {}
  var moneyFormat = '${{amount}}';
  try { moneyFormat = JSON.parse(document.querySelector('[data-bb-offers-money="' + sid + '"]').textContent); } catch (e) {}

  var info = document.querySelector('.product__info-container');
  var form = info && info.querySelector('form[action*="/cart/add"]');
  if (!info || !form) return;

  // Mount above the buy buttons (keep the main form untouched so apps like Amazon's keep working)
  var buyBlock = form.closest('product-form') || form;
  var mountBefore = buyBlock.parentElement && buyBlock.parentElement !== info ? buyBlock.parentElement : buyBlock;
  mountBefore.parentNode.insertBefore(root, mountBefore);
  root.hidden = false;

  function fmt(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.'), whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, whole + '.' + parts[1]);
  }
  function variantId() { var i = form.querySelector('input[name="id"]'); return i ? i.value : null; }
  function qtyInput() { return info.querySelector('input[name="quantity"]') || form.querySelector('input[name="quantity"]'); }

  /* ---------- Tiers ---------- */
  var tiers = Array.prototype.slice.call(root.querySelectorAll('.bb-tier'));
  if (tiers.length) {
    info.classList.add('bb-has-tiers');
    var openInput = root.querySelector('[data-open-qty]');

    function tierQty(t) { return t.dataset.open && openInput ? Math.max(+t.dataset.qty, +openInput.value || +t.dataset.qty) : +t.dataset.qty; }

    function render() {
      var price = prices[variantId()];
      if (price == null) price = prices[Object.keys(prices)[0]] || 0;
      tiers.forEach(function (t) {
        var q = tierQty(t), pct = +t.dataset.pct || 0, full = price * q, total = Math.round(full * (1 - pct / 100));
        t.querySelector('[data-total]').textContent = fmt(total);
        var was = t.querySelector('[data-was]'); was.textContent = pct ? fmt(full) : '';
        t.querySelector('[data-each]').textContent = q > 1 ? fmt(Math.round(total / q)) + ' each' : '';
      });
    }

    function setQty(q) {
      var input = qtyInput();
      if (!input) { // no quantity selector on the page: add one so the form sends it
        input = document.createElement('input'); input.type = 'hidden'; input.name = 'quantity'; form.appendChild(input);
      }
      input.value = q;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function select(t) {
      tiers.forEach(function (o) { o.classList.toggle('is-active', o === t); o.querySelector('input[type=radio]').checked = o === t; });
      setQty(tierQty(t));
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.closest('[data-stepper]')) return;
        select(t);
      });
    });
    root.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var min = +openInput.min || 1;
        openInput.value = Math.min(99, Math.max(min, (+openInput.value || min) + (+b.dataset.step)));
        select(openInput.closest('.bb-tier')); render();
      });
    });
    if (openInput) openInput.addEventListener('input', function () { select(openInput.closest('.bb-tier')); render(); });

    // Keep prices in sync with the selected color / pack
    function later() { setTimeout(render, 60); }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, later);
    }
    info.addEventListener('change', function (e) { if (e.target.closest('variant-selects, variant-radios, .product-form__input')) later(); });
    render();
  }

  /* ---------- Add-ons: added right after the main item lands in the cart ---------- */
  var addonBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-bb-addon]'));
  root.querySelectorAll('[data-bb-addon-variant]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var box = sel.closest('.bb-addon').querySelector('[data-bb-addon]');
      box.value = sel.value; box.checked = true;
    });
  });
  if (addonBoxes.length && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (!evt || evt.source !== 'product-form') return;
      if (String(evt.productVariantId) !== String(variantId())) return; // ignore quick-add from other products
      var items = addonBoxes.filter(function (c) { return c.checked && !c.disabled; }).map(function (c) { return { id: +c.value, quantity: 1 }; });
      if (!items.length) return;
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (json) {
        if (json.status) return;
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(json); }
        else if (json.sections && json.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
        }
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bb-offers' });
      }).catch(function () {});
    });
  }
})();
